import { useCallback, useEffect, useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/KpiCard";
import { download } from "@/components/phones/PhoneRegister";
import { Tabs } from "@/components/tyres/common";
import { VehiclesTab } from "@/components/tyres/VehiclesTab";
import { StockTab } from "@/components/tyres/StockTab";
import { OrdersTab } from "@/components/tyres/OrdersTab";
import { SettingsTab } from "@/components/tyres/SettingsTab";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function TyresPage() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin";
  const [stations, setStations] = useState([]);
  const [stationId, setStationId] = useState("");
  const [tab, setTab] = useState("vehicles");
  const [types, setTypes] = useState([]);
  const [shops, setShops] = useState({ shops: [], defaults: {} });
  const [tick, setTick] = useState(0);
  const loadMeta = useCallback(() => {
    api.get("/tyres/types").then((r) => setTypes(r.data));
    api.get("/tyres/shops").then((r) => setShops(r.data));
  }, []);
  useEffect(() => {
    loadMeta();
    api.get("/stations").then((r) => { setStations(r.data); if (isAdmin && r.data[0]) setStationId((s) => s || r.data[0].id); });
  }, [loadMeta, isAdmin]);
  const sid = isAdmin ? stationId : user.station_id;
  const refresh = () => setTick((x) => x + 1);
  const tabs = [["vehicles", "Furgoni e cambi"], ["stock", "Magazzino"], ["orders", "Ordini"], ...(isAdmin && !user.supervisor ? [["settings", "Tipologie e gommisti"]] : [])];
  const props = { sid, isAdmin, types, shops, tick, refresh };

  return (
    <div className="fade-up">
      <PageHeader title="Gomme" subtitle="Cambi gomme sui furgoni, magazzino della stazione e ordini al gommista.">
        {sid && <Button variant="outline" onClick={() => download("/tyres/export", { station_id: isAdmin ? sid : undefined }, "gomme.xlsx")} data-testid="tyre-export-button"><FileSpreadsheet className="mr-2 h-4 w-4" /> Scarica Excel</Button>}
      </PageHeader>
      {isAdmin && (
        <div className="mb-4 flex gap-2 overflow-x-auto pb-1" data-testid="tyre-station-tabs">
          {stations.map((st) => (
            <button key={st.id} onClick={() => setStationId(st.id)} data-testid={`tyre-tab-${st.id}`}
              className={`shrink-0 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${stationId === st.id ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"}`}>{st.name}</button>
          ))}
        </div>
      )}
      <div className="mb-5"><Tabs value={tab} onChange={setTab} items={tabs} prefix="tyre-section" /></div>
      {!sid ? <p className="text-sm text-slate-500">Seleziona una stazione.</p> : (
        <>
          {tab === "vehicles" && <VehiclesTab {...props} />}
          {tab === "stock" && <StockTab {...props} />}
          {tab === "orders" && <OrdersTab {...props} stationName={stations.find((s) => s.id === sid)?.name || ""} />}
          {tab === "settings" && <SettingsTab types={types} shops={shops} stations={stations} onChanged={loadMeta} />}
        </>
      )}
    </div>
  );
}
